import Axios from "axios";
import config from "../app.config";

export var mailTrashService
export default mailTrashService = {
    getListMailTrash,
    getTrashMailDetail,
    restoreMailTrash,
    deletePermanentlyMailTrash,
}

// list function
async function getListMailTrash(data) {
    let mailBox = data.mailBox
    let queries = data.queries
    return await Axios.get(`${config.LOCAL_API_URL}/getListMailTrash/${mailBox}`, {params: queries})
        .then(response => {
            if(response.data) {
                return Promise.resolve(response.data);
            } else {
                return Promise.reject(response);
            }
        }).catch(error =>{
            return Promise.reject(error);
        })
}

async function getTrashMailDetail(data) {
    return await Axios.get(`${config.LOCAL_API_URL}/getTrashMailDetail/${data.email}/${data.inquiry_id}`)
        .then(response => {
            if(response.data) {
                return Promise.resolve(response.data);
            } else {
                return Promise.reject(response);
            }
        }).catch(error =>{
            return Promise.reject(error);
        })
}

async function restoreMailTrash(data) {
    let mailBox = data['mailBox']
    return await Axios.post(`${config.LOCAL_API_URL}/mailTrash/restore/${mailBox}`, data)
        .then(response => {
            if(response.data) {
                return Promise.resolve(response.data);
            } else {
                return Promise.reject(response);
            }
        }).catch(error =>{
            return Promise.reject(error);
        })
}

async function deletePermanentlyMailTrash(data) {
    let mailBox = data['mailBox']
    return await Axios.delete(`${config.LOCAL_API_URL}/mailTrash/deletePermanently/${mailBox}`,{data: data})
        .then(response => {
            if(response.data) {
                return Promise.resolve(response.data);
            } else {
                return Promise.reject(response);
            }
        }).catch(error =>{
            return Promise.reject(error);
        })
}
